/**
 * Конфігурація додатку
 */

export const config = {
  // API configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || "/api/v1", // Empty = use Vite proxy
    timeout: 10000, // 10 секунд
  },

  // Upload configuration
  upload: {
    maxSize: parseInt(import.meta.env.VITE_UPLOAD_MAX_SIZE || "10485760"), // 10MB default
    supportedFormats: (
      import.meta.env.VITE_SUPPORTED_FORMATS ||
      "image/jpeg,image/jpg,image/png,image/gif,image/webp"
    ).split(","),
    endpoints: {
      single: "/upload",
      multiple: "/upload/multiple",
      business: (businessId: string) => `/business/${businessId}/photos`,
    },
  },

  // Auth configuration
  auth: {
    tokenKey: "auth_token",
    userKey: "auth_user",
    sessionTimeout: 24 * 60 * 60 * 1000, // 24 години в мілісекундах
  },

  // App configuration
  app: {
    name: "Visit Platform",
    version: "1.0.0",
    supportedLanguages: ["ua", "en"] as const,
    defaultLanguage: "ua" as const,
  },

  // Validation rules
  validation: {
    password: {
      minLength: 6,
      maxLength: 128,
    },
    phone: {
      pattern: /^(\+?380|0)[0-9]{9}$/,
      format: "+380XXXXXXXXX",
    },
    email: {
      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    },
    sms: {
      codeLength: 6,
      maxAttempts: 3,
      expirationMinutes: 10,
    },
  },

  // UI configuration
  ui: {
    modal: {
      animationDuration: 300,
    },
    toast: {
      duration: 5000,
      position: "top-right" as const,
    },
  },
} as const;

// Type exports
export type Config = typeof config;
export type SupportedLanguage = (typeof config.app.supportedLanguages)[number];
